'use strict';

const { ApiRequestError } = require('./error/ApiRequestError');

module.exports = {
    ApiRequestError
};



/** WEBPACK FOOTER **
 ** ./public/js/utils/customError.js
 **/